import {gsap} from "gsap";

import { MorphSVGPlugin } from "../plugins/MorphSVGPlugin"
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SpeakerCard from "./SpeakerCard";
gsap.registerPlugin( MorphSVGPlugin, ScrollTrigger );

class Animations {
    constructor() {
        this.initSubscriptionsParallax()
        this.initHeroParallax()
        this.initSpeakerCard()
        this.initRandomCellsMorphing()
    }

    initSpeakerCard() {
        this.speakerCards = [...document.querySelectorAll('.speaker-card')];
        if(this.speakerCards && this.speakerCards.length) {
            this.speakerCards.forEach(el => {
                new SpeakerCard(el)
            })
        }
    }

    initSubscriptionsParallax() {
        this.parallax = [...document.querySelectorAll('.parallax-bg')];

        if(this.parallax && this.parallax.length) {
            this.parallax.forEach(item => {
                gsap.to(item.querySelector('.parallax-bg--inner'), {
                    scrollTrigger: {
                        trigger: item,
                        scrub: true,
                    },
                    yPercent: "+=30",
                    rotateX: 5,
                    ease: "none"
                });
            })
        }
    }

    initHeroParallax() {
        this.parallax = [...document.querySelectorAll('.parallax-hero-bg')];

        if(this.parallax && this.parallax.length) {
            this.parallax.forEach(item => {
                gsap.to(item.querySelector('.parallax-bg--inner'), {
                    scrollTrigger: {
                        trigger: item,
                        scrub: true,
                        start: "top top"
                    },
                    yPercent: "+=50",
                    ease: "none"
                });
            })
        }
    }

    initRandomCellsMorphing() {
        this.randomCellsMorphing = [...document.querySelectorAll('.random-cells-morphing')];

        if(this.randomCellsMorphing && this.randomCellsMorphing.length) {
            this.randomCellsMorphing.forEach(svg => {
                const filledCells = svg.querySelectorAll('.random-cells-filled');
                
                if (filledCells.length) {
                    const singleColor = svg.getAttribute('data-single-color');
                    
                    const colors = singleColor 
                        ? [singleColor, 'transparent'] 
                        : ['#BE4EFF', '#FF7D67', 'transparent'];
                    
                    filledCells.forEach(cell => {
                        if (!cell.getAttribute('fill') || cell.getAttribute('fill') === 'none') {
                            gsap.set(cell, { attr: { fill: 'transparent' } });
                        }
                    });
                    
                    if (singleColor) {
                        filledCells.forEach(cell => {
                            gsap.set(cell, { attr: { fill: 'transparent' } });
                        });
                        
                        const initialCell = filledCells[Math.floor(Math.random() * filledCells.length)];
                        gsap.set(initialCell, { attr: { fill: singleColor } });
                        
                        let currentColoredCell = initialCell;
                        
                        const animateSingleColorPattern = () => {
                            gsap.to(currentColoredCell, {
                                attr: { fill: 'transparent' },
                                duration: 1.2,
                                ease: "sine.inOut",
                                onComplete: () => {
                                    let newCellIndex;
                                    do {
                                        newCellIndex = Math.floor(Math.random() * filledCells.length);
                                    } while (filledCells[newCellIndex] === currentColoredCell);
                                    
                                    currentColoredCell = filledCells[newCellIndex];
                                    
                                    gsap.to(currentColoredCell, {
                                        attr: { fill: singleColor },
                                        duration: 1.2,
                                        ease: "sine.inOut",
                                        onComplete: animateSingleColorPattern
                                    });
                                }
                            });
                        };
                        
                        setTimeout(animateSingleColorPattern, 2000);
                    } else {
                        const animateRandomCell = () => {
                            const randomIndex = Math.floor(Math.random() * filledCells.length);
                            const cell = filledCells[randomIndex];
                            
                            const currentColor = cell.getAttribute('fill');
                            
                            let normalizedCurrentColor = currentColor;
                            if (!currentColor || currentColor === 'none') {
                                normalizedCurrentColor = 'transparent';
                            }
                            
                            const availableColors = colors.filter(color => color !== normalizedCurrentColor);
                            
                            if (availableColors.length === 0) {
                                console.warn('No available colors different from current color');
                                const nextColor = colors[Math.floor(Math.random() * colors.length)];
                                if (nextColor !== normalizedCurrentColor) {
                                    animateCell(cell, nextColor);
                                } else {
                                    setTimeout(animateRandomCell, 100);
                                }
                            } else {
                                const nextColor = availableColors[Math.floor(Math.random() * availableColors.length)];
                                animateCell(cell, nextColor);
                            }
                        };
                        
                        const animateCell = (cell, nextColor) => {
                            gsap.to(cell, {
                                attr: { fill: nextColor },
                                duration: 1.2,
                                ease: "sine.inOut",
                                onComplete: animateRandomCell
                            });
                        };
                        
                        animateRandomCell();
                        
                        setTimeout(() => {
                            animateRandomCell();
                        }, 900);
                    }
                }
            });
        }
    }
}

export default Animations
